import { Box, Card, Checkbox, Chip, Divider, FormControlLabel, Grid, IconButton, Typography, Tooltip, Button, MenuItem, Menu } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Colors } from '../../../../Styles/Colors'
import { ImagePaths } from '../../../../Utility/ImagePaths'
import { AmountFormat, CheckAccessFunc, fetchAndConvertToBase64, formatDateAndTime } from '../../../../Components/CommonFunctions/CommonFunctions'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import RestAPIService from '../../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../../Utility/API/Serviceurls'
import { getCachevalue, localGetItem, setCachevalue } from '../../../../Utility/Services/CacheProviderService'
import { Chart as ChartJS, LineElement, PointElement, CategoryScale, LinearScale, Title, Tooltip as ChartTooltip, Legend } from 'chart.js';
import { Line } from 'react-chartjs-2';
import { DataGrid } from '@mui/x-data-grid'
import Loader from '../../../../Components/Loader';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DocumentPreviewPop from '../../../../Components/Common Components/DocumentPreviewPop'

ChartJS.register(LineElement, PointElement, CategoryScale, LinearScale, Title, ChartTooltip, Legend);


export default function NewIPPatientDetails(props, {fromBillingDetails}) {
    const [states, setStates] = useState({
        moveOtRequest: false,
        isErrorMsg: false,
        isErrorMsgText: '',
        successMsg: false,
        successMsgText: '',
        chipValues: ["Height", "Weight", "BMI", "Temperature"],
        selectedChip: "Height",
        vitalData: [],
        dateList: [],
        weightData: [],
        heightData: [],
        tempData: [],
        BMIData: [],
        loginData: {},
        ipPatientData: {},
        withoutAppoin: {},
        NurseList: [],
        nurseNotesList: [],
        medicationList: [],
        TestReportsData: [],
        investigation: [],
        isLoader: false,
        // image / pdf preview
        viewData: [],
        viewImage: null,
        viewOpen: false,
        isViewClicked: false,
        // menu state
        anchorEl: null,
        selectedRow: null,
        isSelected: false,
        // print preview
        printPreviewPop: false,
        printPreviewData: [],
        pdfName: '',

        IPadvanceAmt: 0,
        IPbillAmt: 0,
        IPrecivedAmt: 0,
        IPbalanceAmt: 0,
        IPconsession: 0,
        IPrefund: 0,

        PHadvanceAmt: 0,
        PHbillAmt: 0,
        PHrecivedAmt: 0,
        PHbalanceAmt: 0,
        PHconsession: 0,
        PHrefund: 0,

        safetyDepAmt: 0,
        ipCreditlimit: 0,
        phCreditlimit: 0,
        prevCreditBal: 0,
        prevAdvanceBal: 0,
        LastVisitObject: {},
        admissionDate: ''
    });

    const chartFont = "Open Sans";

    useEffect(() => {
        const myUser = JSON.parse(localGetItem("loggedInUserInfo"));
        const IPPatientsData = JSON.parse(getCachevalue("IppatientData"));
        const withoutApp = JSON.parse(getCachevalue("withoutAppointment"));
        setStates(prev => ({
            ...prev,
            loginData: myUser,
            ipPatientData: IPPatientsData,
            withoutAppoin: withoutApp,
            moveOtRequest: IPPatientsData?.move_to_ot_request
        }))
    }, [])

    useEffect(() => {
        if (((states?.ipPatientData?.id || states?.ipPatientData?.ip_admission_id) || states?.withoutAppoin?.ip_admission_id) && states?.loginData?.clinic_id) {
            getVitalsData();
            getNurseList();
            getIpDrugChartDetails();
            getTestReports();
            getPatientDetails();
            getAddmissionDetailsData();
            getLastVisitData();
        }
    }, [states?.ipPatientData?.id, states?.ipPatientData?.ip_admission_id, states?.withoutAppoin?.ip_admission_id, states?.loginData?.clinic_id])

    useEffect(() => {
        if (states?.NurseList?.length > 0) {
            getNurseNotesData();
        }
    }, [states?.NurseList?.length > 0])

    const getAddmissionDetailsData = () => {
        try {
            let admissionID = states?.ipPatientData?.id || states?.ipPatientData?.ip_admission_id || states?.withoutAppoin?.ip_admission_id || props?.ip_admission_id;
            RestAPIService.getAll(Serviceurls.FO_PATIENT_ADMISSION + "?admission_id=" + admissionID)
                .then((response) => {
                    if (response.data.status === "success") {
                        setStates(prev => ({
                            ...prev,
                            ipCreditlimit: response?.data?.ip_admission[0]?.ip_admission_credit_limit || 0,
                            phCreditlimit: response?.data?.ip_admission[0]?.ip_pharmacy_credit_limit || 0,
                            admissionDate: response?.data?.ip_admission[0]?.admission_date || '',
                        }))
                    }
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error?.message)
                })
        } catch (error) {
            errorMessage(error?.message)
        }
    }

    const getLastVisitData = () => {
        try {
            let admissionID = states?.ipPatientData?.id || states?.ipPatientData?.ip_admission_id || states?.withoutAppoin?.ip_admission_id || props?.ip_admission_id;
            RestAPIService.getAll(Serviceurls.FO_PATIENT_LAST_VISIT_DATE_AND_BALANCE_AMOUNT + "?patient_id=" + states?.ipPatientData?.patient_id + "&module=IP&branch_id=" + localGetItem("BranchId") + "&admission_id=" + admissionID).
                then((response) => {
                    if (response.data.status === "success") {
                        let Date = response.data?.last_visited_date ? response.data.last_visited_date : ""
                        let Amount = response.data?.total_outstanding ? response.data.total_outstanding : 0
                        let PatientStatus = response.data?.admission_status ? response.data?.admission_status : ""
                        let AdvanceBalance = response.data?.advance_balance ? response.data?.advance_balance : 0
                        let Obj = { "last_visited_date": Date, "total_outstanding": Amount, "status": PatientStatus, advance_balance: AdvanceBalance }
                        setStates(prev => ({
                            ...prev,
                            LastVisitObject: Obj
                        }))
                    }
                    else {
                        errorMessage(response.data.message)
                    }
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (e) {
            errorMessage(e?.message)
        }
    }



    const getPatientDetails = () => {
        try {
            const pharmacyShow = JSON.parse(localGetItem('Show_Pharmacy_Bills_In_FO'))
            let admissionID = states?.ipPatientData?.id || states?.ipPatientData?.ip_admission_id || states?.withoutAppoin?.ip_admission_id || props?.ip_admission_id;
            RestAPIService.getAll((localGetItem('isNewBilling') === "false" ? Serviceurls.FO_PATIENT_DETAILS : Serviceurls.FO_PATIENT_DETAILS_NEW) + "?admission_id=" + admissionID)
                .then((response) => {
                    if (response.data.status === "success") {
                        let iplist = response.data.data[0]
                        const updatedMoveOT = iplist?.move_to_ot_request !== undefined
                            ? iplist?.move_to_ot_request
                            : states?.moveOtRequest;
                        let patientData_ip = JSON.parse(getCachevalue('IppatientData')) || {}
                        patientData_ip['move_to_ot_request'] = updatedMoveOT
                        setCachevalue(JSON.stringify(patientData_ip), 'IppatientData')
                        setStates(prev => ({
                            ...prev,
                            moveOtRequest: updatedMoveOT,
                            IPadvanceAmt: iplist?.advance_amount || 0,
                            IPbillAmt: iplist?.ip_bill_amount || 0,
                            IPrecivedAmt: iplist?.ip_received_amount || 0,
                            IPbalanceAmt: iplist?.ip_balance_amount || 0,
                            IPconsession: iplist?.discount_amount || 0,
                            IPrefund: iplist?.refund_amount || 0,
                            PHadvanceAmt: iplist?.pharmacy_advance_amount || 0,
                            PHbillAmt: iplist?.pharmacy_bill_amount || 0,
                            PHrecivedAmt: iplist?.pharmacy_paid_amount || 0,
                            PHbalanceAmt: iplist?.pharmacy_balance_amount || 0,
                            PHconsession: iplist?.pharmacy_concession_amount || 0,
                            PHrefund: iplist?.pharmacy_refund_amount || 0,
                            safetyDepAmt: iplist?.safety_deposit_amount || 0,
                            ipPatientData: iplist || {},
                        }))
                    }
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error?.message)
                })
        } catch (error) {
            errorMessage(error?.message)
        }
    }

    const getVitalsData = () => {
        try {
            funcLoader(true)
            let admissionID = states?.ipPatientData?.id || states?.ipPatientData?.ip_admission_id || states?.withoutAppoin?.ip_admission_id
            RestAPIService.getAll(Serviceurls.FO_IP_CLINICAL_NOTES_VITAL + `?ip_admission_id=${admissionID}` + `&clinic_id=${states?.loginData?.clinic_id}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        funcLoader(false)
                        setStates(prev => ({
                            ...prev,
                            vitalData: response.data.data
                        }))
                        processVitalData(response.data.data || [])
                    }
                }).catch((e) => {
                    funcLoader(false)
                    errorMessage(e?.response?.data?.message || e?.message)
                })
        } catch (e) {
            funcLoader(false)
            errorMessage(e?.message)
        }
    }

    const getNurseList = () => {
        try {
            funcLoader(true)
            RestAPIService.getAll(Serviceurls.FO_STAFF_LIST + `?clinic_id=${states?.loginData?.clinic_id}`)
                .then((response) => {
                    if (response.data.status === "success") {
                        funcLoader(false)
                        setStates(prev => ({
                            ...prev,
                            NurseList: response?.data?.data || []
                        }))
                    }
                }).catch((error) => {
                    funcLoader(false)
                    errorMessage(error?.response?.data?.message || error.message);
                })
        } catch (error) {
            funcLoader(false)
            errorMessage(error.message);
        }
    }

    const getNurseNotesData = () => {
        try {
            funcLoader(true)
            let admissionID = states?.ipPatientData?.id || states?.ipPatientData?.ip_admission_id || states?.withoutAppoin?.ip_admission_id
            let url = `${Serviceurls.FO_IP_CLINICAL_NURSE_NOTES}?ip_admission_id=${admissionID}`;
            if (props.is_From_IpNotes && states?.loginData?.doctor_id) {
                url = `${url}&doctor_id=${states?.loginData?.doctor_id}`
            }
            RestAPIService.getAll(url)
                .then((response) => {
                    if (response.data.status === 'success') {
                        funcLoader(false)
                        const mappedNurseNotesData = response.data.data.map(item => {
                            let nurse_name = "-";
                            if (item.nurse_profile_id && states?.NurseList?.length > 0) {
                                const foundNurse = states?.NurseList?.find(
                                    nurse => nurse.staff_id === item.nurse_profile_id
                                );
                                nurse_name = foundNurse ? foundNurse.nurse : "-";
                            }

                            return {
                                ...item,
                                nurse_name: nurse_name
                            };
                        });
                        setStates(prev => ({
                            ...prev,
                            nurseNotesList: mappedNurseNotesData
                        }))
                    }
                }).catch((e) => {
                    funcLoader(false)
                    errorMessage(e?.response?.data?.message || e?.message)
                })
        } catch (e) {
            funcLoader(false)
            errorMessage(e?.message)
        }
    }

    const getIpDrugChartDetails = () => {
        try {
            funcLoader(true)
            let admissionID = states?.ipPatientData?.id || states?.ipPatientData?.ip_admission_id || states?.withoutAppoin?.ip_admission_id;
            RestAPIService.getAll(`${Serviceurls.IP_DRUG_CHART}?ip_admission_id=${admissionID}`)
                .then(response => {
                    if (response.data.status === "success") {
                        funcLoader(false)
                        let data = response.data.data?.map((item, i) => {
                            return { ...item, index: i };
                        }) || [];
                        setStates(prev => ({
                            ...prev,
                            medicationList: data || [],
                        }));
                    }
                })
                .catch(error => {
                    funcLoader(false)
                    errorMessage(error?.response?.data?.message || error?.message);
                });
        } catch (e) {
            funcLoader(false)
            errorMessage(e?.message);
        }
    }

    const getTestReports = () => {
        try {
            RestAPIService.getAll(Serviceurls.FO_TEST_REPORT + "?patient_id=" + states?.ipPatientData?.patient_id + "&from_ip=true")
                .then((response) => {
                    if (response.data.status === "success") {
                        setStates(prev => ({
                            ...prev,
                            TestReportsData: response.data.data || [],
                        }))
                    }
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error?.message)
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const calculateBMI = () => {
        return states?.vitalData?.map(item => {
            let height = +item.height_cm / 100;
            if (height > 0) {
                return +(item.weight_kg / (height * height)).toFixed(2); // Round to 2 decimals
            } else {
                return 0;
            }
        });
    };
    const processVitalData = (data) => {
        const dateList = data?.map(item => item.vital_entered_time && formatDateAndTime(item.vital_entered_time));
        const weightData = data?.map(item => item.weight_kg);
        const heightData = data?.map(item => item.height_cm);
        const tempData = data?.map(item => item.temperature);
        const BMIData = calculateBMI(data);
        setStates(prev => ({
            ...prev,
            dateList,
            weightData,
            heightData,
            tempData,
            BMIData
        }));
    };

    const chartOption = () => {
        return {
            responsive: true,
            maintainAspectRatio: false,
            spanGaps: true,
            plugins: {
                legend: { display: true },
                title: { display: false },
                tooltip: {
                    titleFont: { family: chartFont },
                    bodyFont: { family: chartFont }
                }
            },
            scales: {
                x: {
                    grid: { color: 'rgba(0, 0, 0, 0)', drawBorder: false },
                    ticks: {
                        align: 'center',
                        font: { weight: 'bold', family: chartFont, size: 12 }
                    },
                    title: {
                        display: true,
                        text: 'Date',
                        color: 'black',
                        font: { weight: 'bold', size: 12, family: chartFont }
                    }
                },
                y: {
                    beginAtZero: false,
                    ticks: {
                        align: 'center',
                        font: { weight: 'bold', family: chartFont }
                    },
                    title: {
                        display: true,
                        text: states.selectedChip === "Height" ? "Height" : states.selectedChip === "Weight" ? "Weight" : states.selectedChip === "BMI" ? "BMI" : "Temperature",
                        color: 'black',
                        font: { weight: 'bold', size: 12, family: chartFont }
                    }
                }
            }
        };
    };

    const getChartData = () => {
        return {
            labels: states?.dateList,
            datasets: [
                {
                    label: states?.selectedChip === "Height" ? "Height vs Date" : states?.selectedChip === "Weight" ? "Weight vs Date" : states?.selectedChip === "BMI" ? "BMI vs Date" : "Temperature vs Date",
                    data: states?.selectedChip === "Height" ? states?.heightData : states?.selectedChip === "Weight" ? states?.weightData : states?.selectedChip === "BMI" ? states?.BMIData : states?.tempData,
                    backgroundColor: "#04B7B1",
                    borderColor: "#04B7B1"
                },

            ]
        };
    };
    const errorMessage = (msg) => {
        setStates(prev => ({
            ...prev,
            isErrorMsg: true,
            isErrorMsgText: msg
        }))
    }
    const sucessMessage = (msg) => {
        setStates(prev => ({
            ...prev,
            successMsg: true,
            successMsgText: msg
        }))
    }

    const funcLoader = (val) => {
        setStates(prev => ({
            ...prev,
            isLoader: val
        }))
    }

    const ipActionPost = (otval) => {
        try {
            let admissionID = states?.ipPatientData?.id || states?.ipPatientData?.ip_admission_id || states?.withoutAppoin?.ip_admission_id || props?.ip_admission_id;
            let data = {
                ip_admission_id: admissionID,
                move_to_ot_request: otval,
                is_ready_for_final_bill: false,
                is_ip_ot_request: true,
            }
            RestAPIService.create(data, Serviceurls.FO_PATIENT_DETAILS_IP_ACTION).
                then((response) => {
                    if (response.data.status === "success") {
                        sucessMessage(response.data.message);
                        getPatientDetails();
                    } else {
                        errorMessage(response.data.message)
                    }
                }).catch(error => {
                    errorMessage(error?.response?.data?.message || error?.message)
                })
        } catch (error) {
            errorMessage(error?.message)
        }
    }

    const getPatientAdmissionPrint = () => {
        try {
            let admissionID = states?.ipPatientData?.id || states?.ipPatientData?.ip_admission_id || states?.withoutAppoin?.ip_admission_id || props?.ip_admission_id;
            RestAPIService.getAll(Serviceurls.IP_PATIENT_ADMISSION_PRINT + "?ip_admission_id=" + admissionID).
                then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                }).catch((error) => {
                    errorMessage(error.response?.data?.message);
                })
        } catch (error) {
            errorMessage(error?.message)
        }
    }

    const renderPatientDetails = () => {
        const dataofPatient = states?.ipPatientData
        const locationText = `${dataofPatient?.ward_name || '-'} / ${dataofPatient?.block_name || '-'} / ${dataofPatient?.room_number || '-'} / ${dataofPatient?.bed_number || '-'}`
        const attenderText = (dataofPatient?.attender_name && dataofPatient?.attender_mobile) ? `${dataofPatient?.attender_name} - ${dataofPatient?.attender_mobile}` : dataofPatient?.attender_name ? (dataofPatient?.attender_name || '-') : (dataofPatient?.attender_mobile || '-')
        return (
            <Box component={'div'}>
                <Box component={'div'} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pl: '.5vw', pr: '.5vw', height: '5.5vh' }}>
                    <Typography sx={{ fontSize: '.9vw', fontWeight: 'bold' }}>Patient Details</Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'rowx' }}>
                        <FormControlLabel control={<Checkbox checked={states?.moveOtRequest}
                            onChange={(e) => {
                                const checked = e.target.checked;
                                setStates(prev => ({
                                    ...prev,
                                    moveOtRequest: checked
                                }))
                                ipActionPost(checked)
                            }}
                            disabled={fromBillingDetails || states?.withoutAppoin?.ip_admission_id}
                            size='small' />} label={"Move to OT"} />
                        <IconButton>
                            <Box sx={{ width: '1.5vw', height: '1.5vw' }} component={'img'} src={ImagePaths.LabEditButton.default} alt='edit'
                                visibility={(states?.withoutAppoin?.ip_admission_id || !CheckAccessFunc("front_office", "In Patients", "Patient Details", null, "Tab")?.editAccess) ? "hidden" : "none"}
                                onClick={() => {
                                    props.history.push({ pathname: "/IPHome/CreateAppointment", state: { is_PatientDetails: true, isPatientDischarged: states?.ipPatientData?.status === "Checked Out" } })
                                }} />
                        </IconButton>
                        <IconButton>
                            <Box sx={{ width: '1.5vw', height: '1.5vw' }} component={'img'} src={ImagePaths.PrintIcons.default} alt='print'
                                onClick={() => {
                                    getPatientAdmissionPrint();
                                }} />
                        </IconButton>
                    </Box>
                </Box>
                <Divider sx={{ color: '#B5B5B5' }} />
                <Box sx={{ display: 'flex', flexDirection: 'row', height: '14.5vh' }}>
                    <Box sx={{ width: '22%', display: 'flex', justifyContent: 'center', flexDirection: 'column', marginLeft: '.5vw' }}>
                        <img className="eMed_Com_Patient_AvaIcon" style={{ borderColor: (dataofPatient?.patient_type === "new_patient" || dataofPatient?.patient__patient_type === 1) ? "#F1584A" : (dataofPatient?.patient_type === "old_patient") || (dataofPatient?.patient_type === "establish_patient") || (dataofPatient?.patient__patient_type === 3) ? "#800080" : '#29B6F6' }}
                            src={(dataofPatient?.patient_photo_url === null || dataofPatient?.patient_photo_url === "" || dataofPatient?.patient_photo_url === undefined) ? (dataofPatient?.patient_gender === "Male" || dataofPatient?.patient_gender === "m" || dataofPatient?.gender === "m" || dataofPatient?.gender === "Male") ? ImagePaths.Male.default : ImagePaths.Female.default : dataofPatient?.patient_photo_url} alt={'Avatar'} />
                        <Typography sx={{ fontSize: '1vw', fontWeight: 'bold' }}>{`${dataofPatient?.patient_name || '-'} ${dataofPatient?.patient_age || '-'} / ${(dataofPatient?.patient_gender === 'Male' || dataofPatient?.patient_gender === 'm') ? 'M' : (dataofPatient?.patient_gender === 'Female' || dataofPatient?.patient_gender === 'f') ? 'F' : "T"}`}</Typography>
                        <Typography color="text.secondary" sx={{ fontSize: '.8vw' }}>{`${dataofPatient?.patient_account_number || '-'} | ${dataofPatient?.patient__mobile_number || dataofPatient?.mobile_number || '-'}`}</Typography>
                    </Box>
                    <Divider orientation="vertical" flexItem sx={{ color: '#B5B5B5' }} />
                    <Box sx={{ width: '78%', height: '14.5vh' }}>
                        <Box sx={{ height: '7.2vh', marginLeft: '.5vw', display: 'flex', alignItems: 'center' }}>
                            <Grid container spacing={1}>
                                <Grid item xs={3}>
                                    <Typography color="text.secondary" sx={{ fontSize: '.8vw' }}>Reason/Diagnosis</Typography>
                                    {(dataofPatient?.complaints || dataofPatient?.reason_diagnosis)?.length > 28 ? <Tooltip title={dataofPatient?.complaints || dataofPatient?.reason_diagnosis} placement='top' arrow><Typography sx={{ fontSize: '.9vw', fontWeight: 'bold' }}>{`${(dataofPatient?.complaints || dataofPatient?.reason_diagnosis).slice(0, 28) + '...' || '-'}`}</Typography></Tooltip> :
                                        <Typography sx={{ fontSize: '.9vw', fontWeight: 'bold' }}>{`${dataofPatient?.complaints || dataofPatient?.reason_diagnosis || '-'}`}</Typography>}
                                </Grid>

                                <Grid item xs={3}>
                                    <Typography color="text.secondary" sx={{ fontSize: '.8vw' }}>Admitting Consultant</Typography>
                                    {dataofPatient?.doctor_name?.length > 28 ? <Tooltip title={dataofPatient?.doctor_name} placement='top' arrow><Typography sx={{ fontSize: '.9vw', fontWeight: 'bold' }}>{`${dataofPatient?.doctor_name.slice(0, 28) + '...' || '-'}`}</Typography></Tooltip> :
                                        <Typography sx={{ fontSize: '.9vw', fontWeight: 'bold' }}>{`${dataofPatient?.doctor_name || '-'}`}</Typography>}
                                </Grid>

                                <Grid item xs={3}>
                                    <Typography color="text.secondary" sx={{ fontSize: '.8vw' }}>Date Of Admission</Typography>
                                    <Typography sx={{ fontSize: '.9vw', fontWeight: 'bold' }}>{`${states?.admissionDate || '-'}`}</Typography>
                                </Grid>

                                <Grid item xs={3}>
                                    <Typography color="text.secondary" sx={{ fontSize: '.8vw' }}>Room Details</Typography>
                                    {locationText?.length > 28 ? <Tooltip title={locationText} placement='top' arrow><Typography sx={{ fontSize: '.9vw', fontWeight: 'bold' }}>{`${locationText.slice(0, 28) + '...' || '-'}`}</Typography></Tooltip> :
                                        <Typography sx={{ fontSize: '.9vw', fontWeight: 'bold' }}>{`${locationText || '-'}`}</Typography>}
                                </Grid>
                            </Grid>
                        </Box>
                        <Divider sx={{ color: '#B5B5B5' }} />
                        <Box sx={{ height: '7.2vh', marginLeft: '.5vw', display: 'flex', alignItems: 'center' }}>
                            <Grid container spacing={2}>
                                <Grid item xs={3}>
                                    <Typography color="text.secondary" sx={{ fontSize: '.8vw' }}>IP No</Typography>
                                    <Typography sx={{ fontSize: '.9vw', fontWeight: 'bold' }}>{`${dataofPatient?.ip_number || '-'}`}</Typography>
                                </Grid>

                                <Grid item xs={3}>
                                    <Typography color="text.secondary" sx={{ fontSize: '.8vw' }}>Medico-Legal</Typography>
                                    <Typography sx={{ fontSize: '.9vw', fontWeight: 'bold' }}>{`${dataofPatient?.medico_legal_case ? 'Yes' : 'No'}`}</Typography>
                                </Grid>

                                <Grid item xs={3}>
                                    <Typography color="text.secondary" sx={{ fontSize: '.8vw' }}>Patient Type</Typography>
                                    <Typography sx={{ fontSize: '.9vw', fontWeight: 'bold' }}>{dataofPatient?.patient_type === 'review_patient' ? 'Review Patient' : dataofPatient?.patient_type === 'new_patient' ? 'New Patient' : 'Establish Patient'}</Typography>
                                </Grid>

                                <Grid item xs={3}>
                                    <Typography color="text.secondary" sx={{ fontSize: '.8vw' }}>Attender</Typography>
                                    {attenderText?.length > 25 ? <Tooltip title={attenderText} placement='top' arrow><Typography sx={{ fontSize: '.9vw', fontWeight: 'bold' }}>{`${attenderText.slice(0, 25) + '...' || '-'}`}</Typography></Tooltip> :
                                        <Typography sx={{ fontSize: '.9vw', fontWeight: 'bold' }}>{`${attenderText || '-'}`}</Typography>}
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                </Box>
            </Box>
        )
    }

    const getAmountColor = (value) => {
        const num = Number(value) || 0
        if (num < 0) return 'error.main'     // red
        if (num > 0) return 'success.main'   // green
        return 'text.primary'                // black
    }

    const renderCard = (label, amt, amt2) => {
        const amountColor = getAmountColor(amt)
        const amount2Color = getAmountColor(amt2)

        return (
            <Card
                sx={{
                    width: label === 'Concession/Discount' ? '16vw' : '8.5vw',
                    height: '6vw',
                    marginTop: '.5vw',
                    padding: '.5vw',
                    marginRight: '1vw',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-around'
                }}
            >
                <Typography sx={{ fontSize: '0.9vw', flexWrap: 'wrap' }} color="text.secondary">
                    {label}
                </Typography>

                <Tooltip title={AmountFormat(amt)} arrow>
                    <Typography
                        noWrap
                        sx={{
                            fontSize: label === 'Concession/Discount' ? '0.8vw' : '0.95vw',
                            fontWeight: 'bold',
                            color: label === 'Balance' ? amountColor : 'text.primary',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        }}
                    >
                        {label === 'Concession/Discount'
                            ? `IP Concession: ${AmountFormat(amt)}`
                            : label === 'Last Admission Date'
                                ? (states?.LastVisitObject?.last_visited_date || '-')
                                : AmountFormat(amt)}
                    </Typography>
                </Tooltip>
            </Card>
        )
    }

    const renderAmountDetails = () => {
        const pharmacyShow = JSON.parse(localGetItem('Show_Pharmacy_Bills_In_FO'))
        return (
            <Box component={'div'} sx={{ minHeight: '20vh', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <Box component={'div'} sx={{ backgroundColor: 'white', width: '49.5%', border: 'solid #B5B5B5 1px', borderRadius: '2px', }}>
                    <Box sx={{ height: '4vh', display: 'flex', alignItems: 'center' }}>
                        <Typography sx={{ fontSize: '.9vw', fontWeight: 'bold', marginLeft: '.5vw' }}>Summary</Typography>
                    </Box>
                    <Divider textAlign="right" sx={{ color: '#B5B5B5', }} ><span style={{ color: 'black' }}>IP</span></Divider>
                    <Box sx={{ padding: '.5vw', }}>
                        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                            {renderCard('Advance', states?.IPadvanceAmt)}
                            {renderCard('Bill', states?.IPbillAmt)}
                            {renderCard('Received', states?.IPrecivedAmt)}
                            {renderCard('Balance', states?.IPbalanceAmt)}
                            {renderCard('Concession', states?.IPconsession)}
                            {renderCard('Refund', states?.IPrefund)}
                        </Box>
                        {pharmacyShow ? <Divider textAlign="right" sx={{ color: '#B5B5B5' }} ><span style={{ color: 'black' }}>Pharmacy</span></Divider> : null}
                        {pharmacyShow ? <Box sx={{ display: 'flex', flexDirection: 'row', marginTop: '1vw' }}>
                            {renderCard('Advance', states?.PHadvanceAmt)}
                            {renderCard('Bill', states?.PHbillAmt)}
                            {renderCard('Received', states?.PHrecivedAmt)}
                            {renderCard('Balance', states?.PHbalanceAmt)}
                            {renderCard('Concession', states?.PHconsession)}
                            {renderCard('Refund', states?.PHrefund)}
                        </Box> : null}
                    </Box>
                </Box>
                <Box component={'div'} sx={{ backgroundColor: 'white', width: '49.5%', border: 'solid #B5B5B5 1px', borderRadius: '2px', }}>
                    <Box sx={{ height: '4vh', display: 'flex', alignItems: 'center' }}>
                        <Typography sx={{ fontSize: '.9vw', fontWeight: 'bold', marginLeft: '.5vw' }}>Credit History</Typography>
                    </Box>
                    <Divider sx={{ color: '#B5B5B5' }} />
                    <Box sx={{ padding: '.5vw' }}>
                        <Box sx={{ display: 'flex', flexDirection: 'row', width: '100%', flexWrap: 'wrap' }}>
                            {states?.loginData?.is_safety_deposit_enabled ? renderCard('Safety Deposit', states?.safetyDepAmt) : null}
                            {renderCard('IP Credit Limit', states?.ipCreditlimit)}
                            {renderCard('Pharmacy Credit Limit', states?.phCreditlimit)}
                            {renderCard('Previous Credit Balance', states?.LastVisitObject?.total_outstanding)}
                            {renderCard('Previous Advance Balance', states?.LastVisitObject?.advance_balance)}
                            {renderCard('Last Admission Date', 0)}
                        </Box>
                    </Box>
                </Box>
            </Box>
        )
    }
    const renderDetailsData = () => {
        const columns = [
            {
                field: "date_time", headerName: "Date & Time", flex: 0.20, headerAlign: "center", align: "center",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.date_time ? params?.row?.date_time?.length > 15 ?
                    <Tooltip title={params?.row?.date_time} placement='top' arrow><Box>{params?.row?.date_time.slice(0, 15) + '...'}</Box></Tooltip> : params?.row?.date_time : "-"}</Box>)
            },
            {
                field: 'nurse_name', headerName: 'Nurse Name', flex: 0.20,
                renderCell: (params) => {
                    let nurseName = params?.row?.nurse_name;
                    return (
                        <Box>
                            {nurseName ? nurseName?.length > 12 ?
                                <Tooltip placement="top" title={nurseName} arrow>
                                    <Typography>{nurseName.slice(0, 12) + '...'}</Typography>
                                </Tooltip> :
                                <Typography>{nurseName}</Typography> : '-'}
                        </Box>
                    )
                }
            },
            {
                field: "nurse_notes", headerName: "Nurse Notes", flex: 0.60,
                renderCell: (params) => {
                    const rawHTML = params?.row?.nurse_notes || "-"; // Handle empty cases
                    const htmlToPlainText = (str) => {
                        const temp = document?.createElement("div");
                        temp.innerHTML = str;
                        return temp?.textContent || temp?.innerText || "";
                    };

                    const plainText = htmlToPlainText(rawHTML);
                    const isLongText = plainText?.length > 50;

                    return (
                        <Box component={"div"}>
                            {isLongText ? (
                                <Tooltip placement="right" title={<div dangerouslySetInnerHTML={{ __html: rawHTML }} />} arrow>
                                    <span>{plainText?.slice(0, 50) + "..."}</span>
                                </Tooltip>
                            ) : (
                                <span>{plainText}</span>
                            )}
                        </Box>
                    );
                },
            },
        ]
        return (
            <Box component={'div'} sx={{ height: '45vh', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <Box component={'div'} sx={{ backgroundColor: 'white', width: '49.5%', border: 'solid #B5B5B5 1px', borderRadius: '2px' }}>
                    <Box sx={{ height: '4vh', display: 'flex', alignItems: 'center' }}>
                        <Typography sx={{ fontSize: '.9vw', fontWeight: 'bold', marginLeft: '.5vw' }}>Current Vitals</Typography>
                    </Box>
                    <Divider sx={{ color: '#B5B5B5' }} />
                    <Box sx={{ padding: '.5vw', height: '6vh' }}>
                        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", }}>
                            {states?.chipValues?.map((item, index) => (
                                <Chip
                                    className={`eMed_chip ${item === states?.selectedChip ? 'eMed_Chip_OnClick' : 'eMed_Chip_Border'}`}
                                    size="small"
                                    label={item}
                                    key={index}
                                    color="primary"
                                    variant={states?.selectedChip === item ? 'contained' : "outlined"}
                                    onClick={() => { setStates(prev => ({ ...prev, selectedChip: item })) }}
                                    clickable
                                />
                            ))}
                        </Box>
                        <Box sx={{ flexGrow: 1, display: "flex", alignItems: "center", justifyContent: "center", p: 1, height: "35vh" }}>
                            <Line data={getChartData()} options={chartOption()} />
                        </Box>
                    </Box>
                </Box>
                <Box component={'div'} sx={{ backgroundColor: 'white', width: '49.5%', border: 'solid #B5B5B5 1px', borderRadius: '2px' }}>
                    <Box sx={{ height: '4vh', display: 'flex', alignItems: 'center' }}>
                        <Typography sx={{ fontSize: '.9vw', fontWeight: 'bold', marginLeft: '.5vw' }}>Nurse Notes</Typography>
                    </Box>
                    <Divider sx={{ color: '#B5B5B5' }} />
                    <Box sx={{ padding: '.5vw', height: '40vh' }}>
                        <DataGrid
                            className='eMed_nur_notes_grid'
                            rows={states?.nurseNotesList}
                            columns={columns}
                            getRowId={(row) => row?.id}
                            density='compact'
                            components={{
                                NoRowsOverlay: () => (
                                    <Box className='eMed_conf_nodata' sx={{ height: '40vh' }}>
                                        {"No Records To Be Shown"}
                                    </Box>
                                )
                            }}
                            disableRowSelectionOnClick
                            hideFooter
                        />
                    </Box>
                </Box>
            </Box>
        )
    }

    const getS3Key = (async (doc_key) => {
        try {
            const response = await RestAPIService.getAllTwo(Serviceurls.AWS_URL_GET + "?doc_key=" + encodeURIComponent(doc_key));

            if (response.data.status === "success") {
                const Data = response.data;
                return {
                    data_url: Data.data
                };
            }
        } catch (e) {
            errorMessage("Error fetching S3 URL")
        }
    })

    const renderImage = (async (imageData, pdfData) => {
        let tempArr = [];
        if (imageData?.length > 0) {
            for (let i = 0; i < imageData?.length; i++) {
                let image = imageData[i].result_img_url
                if (image !== null) {
                    let doc_key = image;
                    let getData = await getS3Key(doc_key)
                    getData["type"] = "image";
                    tempArr.push(getData)
                }
            }
        }

        setStates(prev => ({
            ...prev,
            viewData: tempArr,
            viewImage: tempArr[0] || null
        }))
        if ((pdfData === true || pdfData?.length > 0) && tempArr[0]?.data_url) {
            window.open(tempArr[0].data_url);
        }
    })

    const getFoLabTestReportPrint = (resultSummaryId, labId) => {
        try {
            RestAPIService.getAll(Serviceurls.LAB_PATIENT_RESULT_PRINT + `?result_summary_id=${resultSummaryId}&laboratory_id=${labId}`)
                .then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message);
        }
    }

    const getFoRadiologyTestReportPrint = (resultSummaryId, radialogyId, paymentStatus) => {
        try {
            RestAPIService.getAll((localGetItem("isNewBilling") === "true" ? Serviceurls.NEW_RAD_RESULT_PRINT : Serviceurls.RAD_RESULT_PRINT) + '?id=' + resultSummaryId + "&radiology_id=" + radialogyId)
                .then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message);
        }
    }

    const getFoInvestTestReportPrint = (resultSummaryId, InvestID) => {
        try {
            RestAPIService.getAll(Serviceurls.NEW_INVESTIGATION_RESULT_PRINT + '?id=' + resultSummaryId + "&investigation_id=" + InvestID)
                .then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message);
        }
    }

    const moreActionOption = (data) => {
        const multi_option = [
            { label: "View Document", value: "viewDocument" },
        ];
        return (
            <div>
                <Tooltip title={"More"} placement='top' arrow>
                    <IconButton
                        onClick={(e) => {
                            setStates(prev => ({
                                ...prev,
                                anchorEl: e.currentTarget,
                                selectedRow: data.id,
                                isSelected: true
                            }))
                        }}
                    >
                        <MoreVertIcon />
                    </IconButton>
                </Tooltip>
                {(states.isSelected && states?.selectedRow == data.id) ?
                    <Menu
                        anchorEl={states?.anchorEl}
                        open={Boolean(states?.anchorEl)}
                        onClose={() => {
                            setStates(prev => ({
                                ...prev,
                                anchorEl: null
                            }))
                        }}
                    >
                        {multi_option.map((option) => (
                            <MenuItem key={option}
                                disabled={option.value === "viewDocument"
                                    ? !Array.isArray(data?.result_document) || data.result_document.length === 0
                                    : false}
                                onClick={() => {
                                    if (option.value === "viewDocument") {
                                        getS3View(data?.result_document)
                                    }
                                }}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </Menu> : null}
            </div>
        )
    }

    const getS3View = (async (documents) => {
        try {
            if (!documents || documents.length === 0) return;

            let previewItems = [];

            for (const doc of documents) {
                const docName = doc.document_name;
                const docKey = doc.document_file;

                const response = await RestAPIService.getAllTwo(Serviceurls.AWS_URL_GET + "?doc_key=" + encodeURIComponent(docKey));

                if (response.data.status === "success") {
                    const fileUrl = response?.data?.data;
                    if (docName.toLowerCase().includes("jpg")) {
                        // Fetch image and convert to blob object URL
                        const fileResponse = await fetch(fileUrl);
                        const blob = await fileResponse.blob();
                        const imageUrl = URL.createObjectURL(blob);
                        previewItems.push({ type: "image", url: imageUrl, name: docName });
                    } else {
                        // PDF or other formats
                        const base64 = await fetchAndConvertToBase64(fileUrl);

                        const pdfBase64 = base64.replace(
                            "data:binary/octet-stream;",
                            "data:application/pdf;"
                        );

                        previewItems.push({ type: "pdf", url: pdfBase64, name: docName });
                    }
                }
            }

            setStates(prev => ({
                ...prev,
                printPreviewPop: true,
                printPreviewData: previewItems,
                pdfName: "Result Preview"
            }))

        } catch (e) {
            errorMessage(e?.response?.data?.message || e?.message)
        }
    })
    const renderDetailsData2 = () => {
        const medic = [
            {
                field: "drug_name", headerName: "Drug Name", flex: 0.30,
                renderCell: (params) =>
                    params?.row?.drug_name?.length > 20 ? (
                        <Tooltip placement='top' arrow title={params?.row?.drug_name}>
                            <span>{params?.row?.drug_name?.slice(20)}...</span>
                        </Tooltip>
                    ) : (
                        params?.row?.drug_name || "-"
                    )
            },
            {
                field: "dosage_type", headerName: "Dosage Type", flex: 0.22,
                renderCell: (params) =>
                    params?.row?.dosage_type?.length > 15 ? (
                        <Tooltip placement='top' arrow title={params?.row?.dosage_type}>
                            <span>{params?.row?.dosage_type.slice(0, 15)}...</span>
                        </Tooltip>
                    ) : (
                        params?.row?.dosage_type || "-"
                    )
            },
            {
                field: "frequency", headerName: "Frequency", flex: 0.21,
                renderCell: (params) =>
                    params?.row?.frequency?.length > 15 ? (
                        <Tooltip placement='top' arrow title={params?.row?.frequency}>
                            <span>{params?.row?.frequency.slice(0, 15)}...</span>
                        </Tooltip>
                    ) : (
                        params?.row?.frequency || "-"
                    )
            },
            {
                field: "nurse", headerName: "Nurse Name", flex: 0.22,
                renderCell: (params) =>
                    params?.row?.nurse?.length > 15 ? (
                        <Tooltip placement='top' arrow title={params?.row?.nurse}>
                            <span>{params?.row?.nurse.slice(0, 15)}...</span>
                        </Tooltip>
                    ) : (
                        params?.row?.nurse || "-"
                    )
            },
        ]
        const inves = [
            {
                field: "report_date", headerName: "Date", flex: 0.15, headerAlign: "center", align: "center",
                renderCell: (params) => {
                    return (
                        <Box component={'div'}>{params?.row?.report_date ? params?.row?.report_date?.length > 10 ?
                            <Tooltip arrow title={params?.row?.report_date} placement='top'>
                                <div>{params?.row?.report_date.slice(0, 10) + '...'}</div>
                            </Tooltip> :
                            params?.row?.report_date : "-"}</Box>
                    )
                }
            },
            {
                field: "report_type", headerName: "Reports Type", flex: 0.2, headerAlign: "center", align: "center",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.report_type ? params?.row?.report_type?.length > 10 ?
                    <Tooltip arrow title={params?.row?.report_type} placement='top'><div>{params?.row?.report_type.slice(0, 10) + '...'}</div></Tooltip> : params?.row?.report_type : "-"}</Box>)
            },
            {
                field: "report_name", headerName: "Test Details", flex: 0.43,
                renderCell: (params) => (<Box component={'div'}>
                    {params?.row?.report_name ? params?.row?.report_name?.length > 30 ?
                        <Tooltip arrow placement='top' title={params?.row?.report_name}>
                            <div>{params?.row?.report_name.slice(0, 30) + '...'}</div></Tooltip> : params?.row?.report_name : "-"}</Box>)
            },
            {
                field: "status", headerName: "Status", flex: 0.29, align: "left",
                renderCell: ({ row }) => {
                    const imageFiles = row?.file_name || [];
                    const pdfFiles = row?.pdf_file || [];
                    const isPdf = imageFiles[0]?.result_img_url?.includes('.pdf');

                    const handleViewClick = () => {
                        if (imageFiles?.length > 0) {
                            setStates(prev => ({
                                ...prev,
                                isViewClicked: true,
                                viewOpen: true,
                                viewData: [],
                                viewImage: null
                            }))
                            setTimeout(() => {
                                renderImage(imageFiles, pdfFiles)
                            }, 1000);
                        } else {
                            errorMessage('No image to be viewed');
                        }
                    };
                    return (
                        <Box component={'div'} display={'flex'} alignItems={'center'} justifyContent={'center'} paddingRight={'0.5vw'}>
                            {(row?.status === 'Result Inprogress') || (row?.status === "Specimen Collected") ?
                                <Typography fontSize={'0.9vw'} fontWeight={600}>{row?.status ? row?.status : ""}</Typography>
                                : ((row?.status === 'Result Delivered') || (row?.status === 'Result Completed')) ?
                                    <Tooltip title={row?.is_outsource ? 'Outsource' : 'View'} placement="top" arrow>
                                        <div>
                                            <Button sx={{ textTransform: 'capitalize' }} className='Common_Btn_Min_Width'
                                                disabled={row?.is_outsource}
                                                onClick={() => { getFoLabTestReportPrint(row?.id, row?.laboratory_id) }}
                                            >View</Button>
                                        </div>
                                    </Tooltip>
                                    : (row?.status === 'Result Saved') || (row?.status === "In Progress") ? <Typography emed_tid={`test_reports_status_text_${row.id}`}>{row?.status}</Typography> :
                                        (row?.status === 'Completed') || (row?.status === 'Dispatched') ?
                                            <Tooltip title={row?.is_outsource ? 'Outsource' : 'View'} placement="top" arrow emed_tid={`test_reports_view_tooltip_${row.id}`}>
                                                <div emed_tid={`test_reports_view_container_${row.id}`}>
                                                    <Button sx={{ textTransform: 'capitalize' }} className='Common_Btn_Min_Width'
                                                        disabled={row?.is_outsource}
                                                        onClick={() => { row?.is_investigation ? getFoInvestTestReportPrint(row?.id, row?.investigation_id) : getFoRadiologyTestReportPrint(row?.id, row?.radiology_id) }}
                                                        emed_tid={`test_reports_view_btn_${row.id}`}
                                                    >View</Button>
                                                </div>
                                            </Tooltip> :
                                            <Box display={"flex"} gap={"0.5vw"} alignItems={"center"}>
                                                <Button sx={{ textTransform: 'capitalize' }} className="Common_Btn_Min_Width"
                                                    //   onClick={isPdf ? handlePdfClick : handleViewClick}
                                                    onClick={handleViewClick}
                                                >
                                                    {/* {isPdf ? <FileUploadIcon color="primary" /> : 'View'} */}
                                                    {'View'}
                                                </Button>
                                            </Box>
                            }
                            {!row?.is_deletable_item && (row?.status === 'Completed' || row?.status === 'Dispatched') ? moreActionOption(row) : null}
                        </Box>)
                }
            }
        ]

        return (
            <Box component={'div'} sx={{ height: '45vh', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <Box component={'div'} sx={{ backgroundColor: 'white', width: '49.5%', border: 'solid #B5B5B5 1px', borderRadius: '2px' }}>
                    <Box sx={{ height: '4vh', width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Box sx={{ width: '50%' }}>
                            <Typography sx={{ fontSize: '.9vw', fontWeight: 'bold', marginLeft: '.5vw' }}>Current Medications</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', width: '50%' }}>
                            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                <Box
                                    sx={{
                                        width: '1vw',
                                        height: '1vw',
                                        backgroundColor: '#E8FEE8'
                                    }}
                                />
                                <Typography fontSize={'.9vw'} marginLeft={'0.5vw'}>Start</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                <Box
                                    sx={{
                                        width: '1vw',
                                        height: '1vw',
                                        backgroundColor: '#FAE4E4'
                                    }}
                                />
                                <Typography fontSize={'.9vw'} marginLeft={'0.5vw'}>Stop</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                <Box
                                    sx={{
                                        width: '1vw',
                                        height: '1vw',
                                        backgroundColor: '#FEF8C3'
                                    }}
                                />
                                <Typography fontSize={'.9vw'} marginLeft={'0.5vw'}>Hold</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                <Box
                                    sx={{
                                        width: '1vw',
                                        height: '1vw',
                                        backgroundColor: 'white',
                                        border: '1px solid black'
                                    }}
                                />
                                <Typography fontSize={'.9vw'} marginLeft={'0.5vw'} marginRight={'.5vw'}>Completed</Typography>
                            </Box>
                        </Box>
                    </Box>
                    <Divider sx={{ color: '#B5B5B5' }} />
                    <Box sx={{ padding: '.5vw', height: '40vh' }}>
                        <DataGrid
                            className='eMed_nur_notes_grid'
                            rows={states?.medicationList}
                            columns={medic}
                            getRowId={(row) => row?.id}
                            density='compact'
                            getRowClassName={({ row }) => {
                                switch (row.status) {
                                    case 'Start':
                                        return 'eMed_drug_status_start';
                                    case 'Stop':
                                        return 'eMed_drug_status_stop';
                                    case 'Hold':
                                        return 'eMed_drug_status_hold';
                                    case 'Completed':
                                        return 'eMed_drug_status_Completed';
                                    default:
                                        return '';
                                }
                            }}
                            components={{
                                NoRowsOverlay: () => (
                                    <Box className='eMed_conf_nodata' sx={{ height: '40vh' }}>
                                        {"No Records To Be Shown"}
                                    </Box>
                                )
                            }}
                            disableRowSelectionOnClick
                            hideFooter
                        />
                    </Box>
                </Box>
                <Box component={'div'} sx={{ backgroundColor: 'white', width: '49.5%', border: 'solid #B5B5B5 1px', borderRadius: '2px' }}>
                    <Box sx={{ height: '4vh', display: 'flex', alignItems: 'center' }}>
                        <Typography sx={{ fontSize: '.9vw', fontWeight: 'bold', marginLeft: '.5vw' }}>Investigations</Typography>
                    </Box>
                    <Divider sx={{ color: '#B5B5B5' }} />
                    <Box sx={{ padding: '.5vw', height: '40vh' }}>
                        <DataGrid
                            className='eMed_nur_notes_grid'
                            rows={states?.TestReportsData}
                            columns={inves}
                            getRowId={(row) => row?.id}
                            density='compact'
                            components={{
                                NoRowsOverlay: () => (
                                    <Box className='eMed_conf_nodata' sx={{ height: '40vh' }}>
                                        {"No Records To Be Shown"}
                                    </Box>
                                )
                            }}
                            disableRowSelectionOnClick
                            hideFooter
                        />
                    </Box>
                </Box>
            </Box>
        )
    }

    const msgClose = () => {
        setStates(prev => ({
            ...prev,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: '',
        }))
    }

    const closePrintPreview = () => {
        setStates(prev => ({
            ...prev,
            printPreviewPop: false,
            printPreviewData: [],
            pdfName: ''
        }))
    }

    // render
    return (
        <Box component={'div'} sx={{ backgroundColor: Colors.Background, width: '94.5vw', height: '80vh', padding: 1, overflowY: 'scroll' }}>
            <Box component={'div'} sx={{ backgroundColor: 'white', width: '100%', height: '20vh', border: 'solid #B5B5B5 1px', borderRadius: '2px' }}>
                {renderPatientDetails()}
            </Box>
            <Box component={'div'} sx={{ width: '100%', minHeight: '20vh', mt: '.5vw' }} >
                {renderAmountDetails()}
            </Box>
            <Box component={'div'} sx={{ width: '100%', height: '45vh', mt: '.5vw' }}>
                {renderDetailsData()}
            </Box>
            <Box component={'div'} sx={{ width: '100%', height: '45vh', mt: '.5vw' }}>
                {renderDetailsData2()}
            </Box>
            {states.isErrorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={states.isErrorMsgText}
                    msgPop={msgClose}
                />
                : null}
            {states.successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={states.successMsgText}
                    msgPop={msgClose}
                />
                : null}
            {states?.printPreviewPop ?
                <DocumentPreviewPop
                    Data={states?.printPreviewData}
                    Title={states?.pdfName}
                    BillData={states?.selectedRow}
                    ClosePopUp={() => { closePrintPreview() }}
                /> : null}
            <Loader loaderOpen={states?.isLoader} />
        </Box>
    )
}
